import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { OutletContext } from './employer-settings-wrapper'
import { Box, Element } from 'react-bulma-components'
import FormError from '../../components/form/request-status/error'
import { extractApiError, ApiError } from '../../api'
import OrganizationAssociationsList from '../../components/organizations/associations-list'
import { OrganizationTypeEnum } from '../../api/organizations'
import {
  useUpdateAssocationMutation,
  useDiscontinueAssociationMutation,
  useReactivateAssociationMutation,
} from '../../queries/organizations'
import SidebarContentTitle from '../../components/layout/sidebar/sidebar-content-title'
import EmployerAgencyExplanation from '../../components/organizations/employer-agency-explanation'
import ConfirmationModal from '../../components/confirmation-modal/confirmation-modal'
import { useModal } from '../../components/modal'

const PartnersAgenciesSettings: React.FC = () => {
  const { employer } = useOutletContext<OutletContext>()

  const updateAssociationMutation = useUpdateAssocationMutation()
  const discontinueMutation = useDiscontinueAssociationMutation()
  const reactivateMutation = useReactivateAssociationMutation()
  const discontinueModal = useModal()
  const [pendingDiscontinueId, setPendingDiscontinueId] = React.useState<string | null>(null)

  const handleAcceptInvitation = (associationId: string) => {
    updateAssociationMutation.mutate({
      employerId: employer._id,
      associationId: associationId,
      status: 'accepted',
    })
  }

  const handleDiscontinue = (associationId: string) => {
    setPendingDiscontinueId(associationId)
    discontinueModal.setIsDisplayed(true)
  }

  const handleDiscontinueConfirm = () => {
    if (!pendingDiscontinueId) return
    discontinueMutation.mutate({
      employerId: employer._id,
      associationId: pendingDiscontinueId,
    })
    discontinueModal.setIsDisplayed(false)
    setPendingDiscontinueId(null)
  }

  const handleReactivate = (associationId: string) => {
    reactivateMutation.mutate({
      employerId: employer._id,
      associationId: associationId,
    })
  }

  const mutationError = discontinueMutation.error || reactivateMutation.error

  return (
    <>
      {mutationError && <FormError extracted={extractApiError(mutationError as ApiError)} />}
      <SidebarContentTitle
        title="Agences d'Interim Partenaires"
        help={<EmployerAgencyExplanation textColor={'white'} />}
      />
      <Box mb={1}>
        <OrganizationAssociationsList
          associations={employer.associations}
          viewType={OrganizationTypeEnum.employer}
          onAcceptInvitation={handleAcceptInvitation}
          onDiscontinue={handleDiscontinue}
          onReactivate={handleReactivate}
        />
      </Box>
      <Element renderAs="p" textColor="grey">
        Pour ajouter une agence partenaire, veuillez en faire la demande à support@teamtim.fr
      </Element>
      <ConfirmationModal
        show={discontinueModal.isDisplayed}
        onCancel={() => discontinueModal.setIsDisplayed(false)}
        onConfirm={handleDiscontinueConfirm}
      >
        Êtes-vous sûr de vouloir interrompre cette collaboration ?
      </ConfirmationModal>
    </>
  )
}

export default PartnersAgenciesSettings
